export default __webpack_public_path__ + "static/media/ArrowLeft.8fecdb24.svg";